module.exports = __webpack_public_path__ + "img/title.ec79d094.svg";